<template>
  <div class="product-card-price200">
    <!--   choose variation   -->


    <!--   show price and quantity manager if price in not null   -->
    <div v-if="selectedVariation != null">
      <!-- show feature image  -->

      <div v-if="calculatePriceAndOffer(product, selectedVariationObject.id)['price'] != null">
        <!--   price and offer    -->

        <!--   quantity manager on authenticated shopping cart    -->
        <div v-if="checkProductOnShoppingCart(product,selectedVariationObject.id)">
          <ShoppingCartQuantityManager200 class=""

                                          :product="product"
                                          :sub_product="selectedVariationObject.id"/>
        </div>
        <!--   quantity manager on unauthenticated shopping cart    -->
        <div v-else>
          <div v-if="quantityChecker(1,product,selectedVariationObject.id)">

            <div class="my-2"
                 v-if="findAttributeOnSiteInfo('product_unit_warning')[0] >= findProductQuantity(product,selectedVariationObject.id) && findProductQuantity(product,selectedVariationObject.id) != 0">
              <!--  show warning when product reach his limit    -->
              <p v-html="$t('product.quantity_warning', {quantity: findProductQuantity(product, selectedVariationObject.id)})"></p>
            </div>


            <div class="">
              <div class="" v-if="isCartTypeOnUnAuthenticated()">
                <button v-if="!checkProductOnShoppingCart(product,selectedVariationObject.id)"
                        @click="addToCartWrapper(product,selectedVariationObject.id)"
                        class="btn-append shadow-sm ml-2  btn rounded-pill row text-white btn-primary"
                        v-t="`product.add_to_cart_physical`">
                </button>
              </div>
            </div>

          </div>
          <div v-else>
            <button
                    class="btn-append shadow-sm ml-2  btn rounded-pill row text-white btn-primary product-card-price-200-out-of-quantity"
                    v-t="`product.out_of_quantity`">
            </button>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {
  checkProductOnShoppingCart,
  shoppingCartFunctions
} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ShoppingCartFunctions";
import {productFeatureName, productFeatureSubProduct} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product'
import mA from '../../Tags/A'
import mShoppingCartQuantityManager1 from '../ShoppingCartQuantityManager1'
import ShoppingCartQuantityManager200 from "../../Product/ShoppingCartQuantityManager200.vue";

export default {
  name: "ProductCardPrice200",
  props: {
    product: {},
    feature: {}
  },
  data() {
    return {
      selectedVariation: null,
      selectedVariationObject: {},
    }
  },
  components: {
    ShoppingCartQuantityManager200,
    mA,
    mShoppingCartQuantityManager1,
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'User/isAuthenticated',
      order: "ShoppingCart/getSidebarBasketData",
    }),
  },
  methods: {
    checkProductOnShoppingCart,
    productFeatureName,
    ...shoppingCartFunctions,
    productFeatureSubProduct,
    selectVariation(product, feature) {
      this.selectedVariation = feature.id
      this.selectedVariationObject = feature
    },
    /* original */
    async addToCartWrapper() {
      // create this function to do some stuff after we add item to order
      await this.addToCart(...arguments)
      await this.refreshComponent()
    },
    refreshComponent() {
      this.$forceUpdate();
    },
  },
  mounted() {
    this.selectedVariation = this.feature.id
    this.selectedVariationObject = this.feature
    window.addEventListener('click', this.refreshComponent);
    window.addEventListener('DOMContentLoaded', this.refreshComponent);
  },
}
</script>

<style scoped>

.btn-append {
  width: 136px;
}
</style>